module.exports = __webpack_public_path__ + "static/media/signals-ss.93ee6b8e.png";